import React, { useState } from "react";
import { 
    Navigation,
    HeaderItemWrapper,
    Img,
    MobileMenuBar,
    MobileMenuContent,
    HeaderListItemWrapper
} from './styles'
import { HeaderList } from '../HeaderList/index';
import LogoImg from '../../assets/home/bacchusdrinks-logo-header.svg';
import mobileBars from '../../assets/home/icon-menu.svg';
import chart from '../../assets/home/korpa.svg';
import { HeaderItem } from '../DesktopMenu/styles';
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import PersonIcon from '@mui/icons-material/Person';
import { indigo } from '@mui/material/colors';
import LanguageSelect from "../LanguageSelect";
import { useTranslation } from "react-i18next";

const MobileMenu = (props) => {
    const navigate = useNavigate();
    const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);
    const [chartStorage] = useState(getCookie('cart'));
    const [isLoggedIn] = useState(getCookie('token'));
    const [isAdmin] = useState(getCookie('isAdmin') === 'true');
    const { t } = useTranslation();

    const redirecting = (route) => {
        setIsOpenMobileMenu(!isOpenMobileMenu);
        if(route === '/') return navigate("/");
        if(route === '/shop') return navigate("/shop");
        if(route === '/privacy-policy') return navigate("/privacy-policy");
        if(route !== '/') {
            navigate("/")
            setTimeout(() => {
                document.getElementById(route).scrollIntoView();
            }, 0)
            return;
        };
    }

    return(
        <Navigation single={props.single}>
            <HeaderItemWrapper>
                <Img src={LogoImg} onClick={() => navigate("/")} />
            </HeaderItemWrapper>
            <HeaderItemWrapper>
                <MobileMenuBar src={mobileBars} onClick={() => setIsOpenMobileMenu(!isOpenMobileMenu)}/>
            </HeaderItemWrapper>
            <MobileMenuContent isOpenMobileMenu={isOpenMobileMenu}>
                    {
                        isOpenMobileMenu && [
                            HeaderList
                                .filter(item => isAdmin ? item : (item.name !== 'admin panel') )
                                .map(item => (
                                    <HeaderListItemWrapper key={item.id}>
                                        <HeaderItem onClick={() => redirecting(item.route)}>{t(item.name)}</HeaderItem>
                                    </HeaderListItemWrapper>
                                )),
                                isAdmin && <HeaderListItemWrapper key={'admin-panel'}><HeaderItem onClick={() => navigate('/admin-panel')}>{t('adminPanel')}</HeaderItem></HeaderListItemWrapper>,
                                <div key={'loginAndChart'}>
                                    <HeaderListItemWrapper>
                                        {isLoggedIn ?
                                            <PersonIcon 
                                                onClick={() => navigate('/profile')}
                                                sx={{
                                                    fontSize: "30px",
                                                    color: indigo[50],
                                                }}
                                                />
                                            :
                                            <HeaderItem onClick={() => navigate('/login')}>{t('login')}</HeaderItem>
                                        }
                                    </HeaderListItemWrapper>
                                    <HeaderListItemWrapper>
                                        <LanguageSelect/>
                                    </HeaderListItemWrapper>
                                    <HeaderListItemWrapper>
                                        {chartStorage && 
                                            <Img src={chart} small onClick={() => navigate('/chart')}/>
                                        }
                                    </HeaderListItemWrapper>
                                </div>
                        ]
                    }
            </MobileMenuContent>
        </Navigation>
    )
}
export default MobileMenu;
